import { render, staticRenderFns } from "./block2.vue?vue&type=template&id=94805d46&scoped=true"
import script from "./block2.vue?vue&type=script&lang=js"
export * from "./block2.vue?vue&type=script&lang=js"
import style0 from "./block2.vue?vue&type=style&index=0&id=94805d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94805d46",
  null
  
)

export default component.exports